<template>
    <div class="py-3">
        <span class="subtitle-2">
            Rute
            <span>{{ name }}</span>
        </span>
        |
        <span>{{ origin }} - {{ destination }}</span>
        |
        <span v-if="originDeparture">{{ time(originDeparture) }}</span>
    </div>
</template>

<script lang="ts" setup>
import { useDateTimeFilters } from '@/helpers/useDateTimeFilters';

defineProps<{
    name: string;
    origin: string;
    destination: string;
    originDeparture: Date;
}>();
const { time } = useDateTimeFilters();
</script>
